import { Component, AfterViewInit } from '@angular/core';
import { GridOptions } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { DeliRouteService } from '../../../service/deli-route/deli-route.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';

@Component({
  selector: 'app-wa9173',
  templateUrl: './wa9173.component.html',
  styleUrls: ['./wa9173.component.css']
})
export class Wa9173Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA9173:配送ルートマスタ照会';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public config = config;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  private errorInfo = '';

  constructor(private router: Router, private deliRouteService: DeliRouteService, private commonService: CommonService, private dialogsService: DialogsService) {
    this.gridOptions = <GridOptions>{
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,
      onColumnResized: this.saveColumnWidth,
      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa9173_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        width: 40,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        pinned: true
      },
      {
        headerName: '荷主コード',
        field: 'ownerCd',
        width: this.getColumnWidth('ownerCd', 100)
      },
      {
        headerName: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 200)
      },
      {
        headerName: '配送ルートコード',
        field: 'delirouteCd',
        sort: 'asc',
        width: this.getColumnWidth('delirouteCd', 200)
      },
      {
        headerName: '配送ルート名',
        field: 'delirouteTx',
        width: this.getColumnWidth('delirouteTx', 200)
      },
      {
        headerName: '配送エリアコード',
        field: 'deliareaCd',
        width: this.getColumnWidth('deliareaCd', 200)
      },
      {
        headerName: '配送エリア名',
        field: 'deliareaTx',
        width: this.getColumnWidth('deliareaTx', 200)
      },
      {
        headerName: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 200)
      },
      {
        headerName: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 100)
      },
      {
        headerName: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 200)
      },
      {
        headerName: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 100)
      }
    ];
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa9173_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa9173_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      if (column.colId !== '0') {
        localStorage.setItem(`wa9173_${column.colId}_idx`, `${idx}`);
      }
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'エクスポート',
        subMenu: [
          {
            name: 'チェックした行をCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv({ onlySelected: true }));
            }
          },
          {
            name: 'すべてCSVエクスポート',
            action: () => {
              download(params.api.getDataAsCsv());
            }
          },
          'excelExport'
        ]
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonDubleMargin;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() {
    this.onSubmit();
  }

  onSubmit() {
    this.working = true;
    this.deliRouteService
      .get()
      .then(outputJson => {
        console.log(outputJson);
        this.rowData = outputJson.deliroutes;
        this.working = false;
      })
      .catch(error => {
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
        this.working = false;
      });
  }

  insert() {
    this.router.navigate(['wa9174']);
  }

  update() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    sessionStorage.setItem('deliroute', JSON.stringify(this.rowData[selectedIndex]));
    this.router.navigate(['wa9175']);
  }

  delete() {
    if (this.gridOptions.api.getSelectedNodes().length !== 1) {
      this.errorInfo = '対象を1行だけ選択して下さい';
      return;
    }
    const selectedIndex = this.gridOptions.api.getSelectedNodes()[0]['id'];
    const selectedId = this.rowData[selectedIndex]['delirouteId'];
    const selectedOwnerId = this.rowData[selectedIndex]['ownerId'];
    this.dialogsService.confirm('確認', '削除したデータは復活できません。削除してよろしいですか？').subscribe(res => {
      if (res === true) {
        this.working = true;
        this.deliRouteService
          .delete(selectedOwnerId, selectedId)
          .then(outputJson => {
            this.working = false;
            this.onSubmit();
            this.dialogsService.info('完了', '削除が完了しました。');
          })
          .catch(error => {
            this.working = false;
            console.log(this.commonService.getErrorMessage(error));
            this.errorInfo = this.commonService.getErrorMessage(error);
          });
      }
    });
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9173/wa9173.component.ts